import type { JsonApiResponseSingle } from 'json-api-normalizer';

import api from 'api/apiInstance';
import { mapFormData } from 'helpers/formData';

export interface ClientFinancialStrategiesExistingImagesPatchOptions {
  existingImageId: number;
}

export function clientFinancialStrategiesExistingImagesApi(path: string) {
  return {
    path,
    PATCH: (params: ClientFinancialStrategiesExistingImagesPatchOptions) =>
      api.patch<JsonApiResponseSingle>(path, {
        data: {
          attributes: mapFormData(params),
        },
      }),
  };
}
